import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {ErrorComponent} from './modules/common/error/error.component';
import {AuthGuard} from './auth/auth.guard';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/datev/income-tax-documents/wizard/get-firma',
    pathMatch: 'full'
  },
  {
    path: 'datev/income-tax-documents/wizard',
    redirectTo: '/datev/income-tax-documents/wizard/get-firma',
    pathMatch: 'full',
  },
  {
    path: 'datev/income-tax-documents/wizard/login',
    loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-login/datev-wizard-login.component').then(m => m.DatevWizardLoginComponent),
  },
  {
    // WORKAROUND: Parametrisierte Route für DATEV-Login-Callback
    // Diese Route nimmt die DATEV-OAuth2-Parameter als Route-Parameter statt Query-Parameter,
    // um Konflikte mit dem OAuth-Handler der Anwendung zu vermeiden.
    // Kontext: Sowohl die App (für JustFarming-Portal-Auth) als auch DATEV nutzen OAuth2,
    // mit identischen Parameter-Namen ('code', 'state'). Der App-OAuth-Handler würde die
    // DATEV-Parameter fälschlicherweise als eigene Authentifizierungs-Parameter interpretieren.
    //
    // HINWEIS: Die Parameter werden URL-encoded übertragen (siehe login.effects.ts),
    // um Sonderzeichen in OAuth-Parametern (besonders "/" im session_state) zu handhaben.
    // Der Angular Router decoded diese automatisch beim Routing.
    path: 'datev/income-tax-documents/wizard/login/code/:code/state/:state/session-state/:sessionState',
    loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-login/datev-wizard-login.component').then(m => m.DatevWizardLoginComponent),
  },
  {
    // WORKAROUND: Parametrisierte Route für DATEV-Login-Fehler
    // Wenn der DATEV-OAuth2-Flow mit einem Fehler abbricht (z.B. User lehnt ab),
    // werden error und error_description als Query-Parameter zurückgeliefert.
    // Diese Route konvertiert sie zu Route-Parametern, um Konflikte mit dem
    // App-OAuth-Handler zu vermeiden (gleiche Logik wie beim Success-Flow).
    //
    // HINWEIS: Die Parameter werden URL-encoded übertragen (siehe login.effects.ts).
    // Der Angular Router decoded diese automatisch beim Routing.
    path: 'datev/income-tax-documents/wizard/login/error/:errorCode/error-description/:errorDescription/state/:state',
    loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-login/datev-wizard-login.component').then(m => m.DatevWizardLoginComponent),
  },
  {
    path: 'datev/income-tax-documents/wizard',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'get-firma',
        loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-get-firma/datev-wizard-get-firma.component').then(m => m.DatevWizardGetFirmaComponent),
      },
      {
        path: 'case-selection/inhaber/:firmenId',
        loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-case-selection/datev-wizard-case-selection.component').then(m => m.DatevWizardCaseSelectionComponent),
      },
      {
        path: 'client-id/inhaber/:firmenId/fall/:fall',
        loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-client-id/datev-wizard-client-id.component').then(m => m.DatevWizardClientIdComponent),
      },
      {
        path: 'export-date/inhaber/:firmenId/fall/:fall/client/:clientId',
        loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-export-date/datev-wizard-export-date.component').then(m => m.DatevWizardExportDateComponent),
      },
      {
        path: 'export-date/inhaber/:firmenId',
        loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-export-date/datev-wizard-export-date.component').then(m => m.DatevWizardExportDateComponent),
      },
      {
        path: 'config-exists/inhaber/:firmenId/client/:clientId',
        loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-config-exists/datev-wizard-config-exists.component').then(m => m.DatevWizardConfigExistsComponent),
      },
      {
        path: 'config-exists/inhaber/:firmenId',
        loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-config-exists/datev-wizard-config-exists.component').then(m => m.DatevWizardConfigExistsComponent),
      },
      {
        path: 'config-details/export-config-id/:exportConfigId',
        loadComponent: () => import('./modules/routes/datev-wizard/datev-wizard-config-details/datev-wizard-config-details.component').then(m => m.DatevWizardConfigDetailsComponent),
      },
    ],
  },
  {
    path: 'datev',
    loadChildren: () => import('./modules/datev/datev.module').then(m => m.DatevModule),
  },
  {
    path: 'error/:code',
    component: ErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      scrollPositionRestoration: 'top',
      preloadingStrategy: PreloadAllModules,
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
